/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaginationInfo } from './PaginationInfo';
import {
    PaginationInfoFromJSON,
    PaginationInfoFromJSONTyped,
    PaginationInfoToJSON,
    PaginationInfoToJSONTyped,
} from './PaginationInfo';
import type { Asset } from './Asset';
import {
    AssetFromJSON,
    AssetFromJSONTyped,
    AssetToJSON,
    AssetToJSONTyped,
} from './Asset';

/**
 * 
 * @export
 * @interface GetAssetsResponse
 */
export interface GetAssetsResponse {
    /**
     * 
     * @type {PaginationInfo}
     * @memberof GetAssetsResponse
     */
    paginationInfo: PaginationInfo;
    /**
     * 
     * @type {Array<Asset>}
     * @memberof GetAssetsResponse
     */
    assets: Array<Asset>;
}

/**
 * Check if a given object implements the GetAssetsResponse interface.
 */
export function instanceOfGetAssetsResponse(value: object): value is GetAssetsResponse {
    if (!('paginationInfo' in value) || value['paginationInfo'] === undefined) return false;
    if (!('assets' in value) || value['assets'] === undefined) return false;
    return true;
}

export function GetAssetsResponseFromJSON(json: any): GetAssetsResponse {
    return GetAssetsResponseFromJSONTyped(json, false);
}

export function GetAssetsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAssetsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'paginationInfo': PaginationInfoFromJSON(json['paginationInfo']),
        'assets': ((json['assets'] as Array<any>).map(AssetFromJSON)),
    };
}

export function GetAssetsResponseToJSON(json: any): GetAssetsResponse {
    return GetAssetsResponseToJSONTyped(json, false);
}

export function GetAssetsResponseToJSONTyped(value?: GetAssetsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'paginationInfo': PaginationInfoToJSON(value['paginationInfo']),
        'assets': ((value['assets'] as Array<any>).map(AssetToJSON)),
    };
}

